module.exports = __webpack_public_path__ + "img/fig42.35f7f6ca.jpg";